import React, { forwardRef } from 'react';
import { Icon } from './Icon';
import { cx } from './cx';

const ICON_SIZE = { sm: 15, md: 17, lg: 18 };

// variant: primary | secondary | soft | ghost | danger | danger-ghost
// Белого текста на зелёном нет: у primary текст графитовый (правило бренда, контраст 1.6:1).
export const Button = forwardRef(function Button(
    {
        variant = 'secondary',
        size = 'md',
        icon,
        iconRight,
        loading = false,
        block = false,
        disabled,
        type = 'button',
        as: Tag = 'button',
        className,
        children,
        ...rest
    },
    ref
) {
    const s = ICON_SIZE[size] || 17;
    const isButton = Tag === 'button';
    return (
        <Tag
            ref={ref}
            type={isButton ? type : undefined}
            className={cx(
                'ds-btn',
                `ds-btn--${variant}`,
                size !== 'md' && `ds-btn--${size}`,
                block && 'ds-btn--block',
                loading && 'is-loading',
                className
            )}
            disabled={isButton ? disabled || loading : undefined}
            aria-disabled={!isButton && (disabled || loading) ? true : undefined}
            aria-busy={loading || undefined}
            {...rest}
        >
            {loading && <span className="ds-spinner" style={{ '--_s': `${s - 2}px` }} aria-hidden="true" />}
            <span className="ds-btn__label">
                {icon && <Icon name={icon} size={s} />}
                {children}
                {iconRight && <Icon name={iconRight} size={s} />}
            </span>
        </Tag>
    );
});

// Кнопка-иконка: подпись обязательна — она же aria-label и всплывающая подсказка.
export const IconButton = forwardRef(function IconButton(
    { icon, label, variant = 'ghost', size = 'md', className, ...rest },
    ref
) {
    return (
        <Button
            ref={ref}
            variant={variant}
            size={size}
            className={cx('ds-btn--icon', className)}
            aria-label={label}
            title={label}
            {...rest}
        >
            <Icon name={icon} size={ICON_SIZE[size] || 17} />
        </Button>
    );
});

export function ButtonGroup({ className, children, ...rest }) {
    return (
        <div className={cx('ds-btn-group', className)} {...rest}>
            {children}
        </div>
    );
}
